module.exports = __webpack_public_path__ + "img/logo.bec4c126.png";